import { Box, Paper } from '@mui/material';
import type { ReactNode } from 'react';
import ForgeWordmark from './ForgeWordmark.tsx';

// The sign-in page's background: NLC's night blue with the cyan glow.
export const PUBLIC_BACKGROUND =
  'radial-gradient(circle at 50% 14em, rgba(47, 208, 230, 0.18) 0%, rgba(6, 10, 18, 0) 62%), linear-gradient(#060a12, #060a12)';

/** The card the public pages share with the sign-in page, for pages outside react-admin's <Login>. */
const PublicPage = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      px: 2,
      backgroundImage: PUBLIC_BACKGROUND
    }}
  >
    <Paper
      sx={{
        mt: '6em',
        mb: 4,
        width: '100%',
        maxWidth: 380,
        borderRadius: 3,
        p: 3,
        textAlign: 'center'
      }}
    >
      <ForgeWordmark centered />
      {children}
    </Paper>
  </Box>
);

export default PublicPage;
